import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getAppWorkerByUsername } from "../Actions/API/WorkerActions"
import { APIAppWorker } from "../Models/API/AppWorker"
import { findValue } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"

export function useAppWorker(
    appID: string,
    username?: string,
    skipFetch: boolean = false
): FetchState<APIAppWorker> {
    const dispatch = useDispatch()
    const entry = useAppState(state =>
        username === undefined
            ? undefined
            : findValue(
                  state.api.workers.app[appID],
                  worker =>
                      worker.worker.type === "USER" &&
                      worker.worker.userUsername === username
              )
    )

    useEffect(() => {
        if (entry === undefined && username !== undefined && !skipFetch) {
            dispatch(getAppWorkerByUsername(appID, username))
        }
    }, [appID, dispatch, entry, skipFetch, username])

    return useMemo(
        () => (entry === undefined ? undefined : Result.ok(entry)),
        [entry]
    )
}
